import React from 'react'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {FancyCheckmark} from 'common/FancyCheckmark'
import styles from './SaveAsNewRouteModal.scss'
import {errorMessage} from 'lib/styleguide/base.scss'
import fetchJSON from 'lib/fetchJSON'
import p from 'prop-types'
import {TrackLocation} from 'data/records'

export const SAVE_AS_NEW_ROUTE_MODAL = 'SAVE_AS_NEW_ROUTE_MODAL'

export class SaveAsNewRouteModal extends React.PureComponent {
  static propTypes = {
    highlightSlice: p.array,
    onRequestClose: p.func
  }

  constructor (props) {
    super(props)
    this.state = {
      name: ''
    }
  }

  onInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  saveRoute = (e) => {
    e && e.preventDefault()

    const {highlightSlice, troute, objectType} = this.props
    const {name} = this.state

    const indexes = highlightSlice.map(TrackLocation.closestIndex)

    const postData = {
      i: indexes[0],
      count: indexes[1] - indexes[0],
      assetType: objectType,
      assetId: troute.id,
      name
    }

    this.setState({savePending: true})
    fetchJSON(`/routes/new_from_slice.json`, postData)
      .then(saveResult => this.setState({saveResult, saveError: null, savePending: false}))
      .catch(saveError => this.setState({saveError, saveResult: null, savePending: false}))
  }

  render () {
    const {onRequestClose} = this.props
    const {name, saveResult, saveError, savePending} = this.state

    return (
      <ConfirmationDialog
        title='Save as a route'
        maxWidth='600px'
        confirmText={saveResult ? 'Close' : 'Create'}
        onCancel={onRequestClose}
        onRequestClose={onRequestClose}
        showCancel={!saveResult}
        onConfirm={saveResult ? onRequestClose : this.saveRoute}
        confirmPending={savePending}>
        <div className={styles.SaveAsNewRouteModal}>
          {!saveResult && <form onSubmit={this.saveRoute}>
            <p className={styles.lessMargin}>
              A route is just a map of the ride without any time data associated with it. You can edit a route to help you plan future rides.
            </p>
            <label htmlFor='name'>Name:</label>
            <input type='text' id='name' onChange={this.onInputChange} value={name} name='name' />
          </form>}
          {saveError && <div className={errorMessage}>
            Oop! There was an error saving that route.  Please try again.
          </div>}
          {saveResult && <div className={styles.successMessage}>
            <FancyCheckmark />
            Your route was saved. You can view it here: <a href={`/routes/${saveResult.id}`} target='_blank'>{saveResult.name}</a>
          </div>}
        </div>
      </ConfirmationDialog>
    )
  }
}
